import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminProveedoresPage } from "@/features/admin-proveedores/components/AdminProveedoresPage";
import { proveedoresAdminQueryOptions } from "@/features/admin-proveedores/hooks/use-proveedores-admin";

/** Prellenado del alta desde la bandeja «Solicitudes de catálogos» (RFC + razón social del emisor). */
export interface ProveedoresSearch {
  altaRfc?: string;
  altaRazonSocial?: string;
}

export const Route = createFileRoute("/_authed-tw/admin/proveedores")({
  validateSearch: (search: Record<string, unknown>): ProveedoresSearch => ({
    // Un identificador extranjero puede ser numérico · el router lo parsea como número.
    altaRfc:
      typeof search.altaRfc === "number"
        ? String(search.altaRfc)
        : typeof search.altaRfc === "string" && search.altaRfc.trim()
          ? search.altaRfc.trim()
          : undefined,
    altaRazonSocial:
      typeof search.altaRazonSocial === "string" && search.altaRazonSocial.trim() ? search.altaRazonSocial.trim() : undefined,
  }),
  // Precarga la primera página (params default del componente) · el primer
  // paint es síncrono; filtros/páginas posteriores se fetchean on-demand.
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.adminProveedores])
      ? queryClient.ensureQueryData(proveedoresAdminQueryOptions({ page: 1, pageSize: 15 }))
      : undefined,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminProveedores]}>
      <AdminProveedoresPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
